
import { format } from "date-fns"

export default function StudyMetrics({ milestoneData, siteData, latestEnrolments }) {
  console.log("StudyMetrics - milestoneData (received):", milestoneData)
  console.log("StudyMetrics - siteData (received):", siteData)
  console.log("StudyMetrics - latestEnrolments (received):", latestEnrolments)

  const maxMilestoneCount = Math.max(...milestoneData.map((m) => Number(m.count)), 1)
  const maxSiteCount = Math.max(...siteData.map((s) => Number(s.count)), 1)

  console.log("StudyMetrics - maxMilestoneCount:", maxMilestoneCount)
  console.log("StudyMetrics - maxSiteCount:", maxSiteCount)

  // Function to format patient ID
  const formatPatientId = (id) => {
    if (!id) return ""
    return `${id.substring(0, 4)}...${id.substring(id.length - 4)}`
  }

  // Function to format date and time
  const formatDateTime = (timestamp) => {
    if (!timestamp) return ""
    try {
      return format(new Date(timestamp), "yyyy/MM/dd HH:mm a")
    } catch (e) {
      console.error("Error formatting date:", timestamp, e)
      return "[Invalid Date]"
    }
  }

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Milestones Progression Chart */}
        <div className="bg-white p-4 rounded-lg shadow-lg">
          <h3 className="text-lg font-medium mb-4">Milestones progression</h3>
          <div className="relative h-80">
            {/* Y-axis label - offset from chart */}
            <div className="absolute left-0 top-0 h-64 flex flex-col justify-center">
              <div className="transform -rotate-90 translate-y-0 text-sm text-gray-500 whitespace-nowrap ml-[-20px]">
                N° of patients
              </div>
            </div>

            {/* Main chart container */}
            <div className="ml-10 h-full flex flex-col">
              {/* Chart bars area */}
              <div className="h-64 flex items-end">
                {milestoneData.length > 0 ? (
                  milestoneData.map((milestone) => {
                    const barHeight = (Number(milestone.count) / maxMilestoneCount) * 200
                    console.log(
                      `Milestone ${milestone.title} (count: ${milestone.count}) - Calculated height: ${barHeight}px`,
                    )
                    return (
                      <div key={milestone.number} className="flex flex-col items-center flex-1 justify-end">
                        <div
                          className="w-4/5 bg-blue-200 rounded-t-3xl flex items-center justify-center"
                          style={{ height: `${barHeight}px` }}
                        >
                          <span className="font-medium py-2">{milestone.count}</span>
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <div className="flex items-center justify-center w-full h-full text-gray-500">
                    No milestone data available.
                  </div>
                )}
              </div>

              {/* Baseline (border-b) */}
              <div className="w-full border-b border-gray-300"></div>

              {/* Milestone labels below baseline */}
              <div className="w-full flex mt-2">
                {milestoneData.map((milestone) => (
                  <div key={milestone.number} className="flex-1 text-center">
                    <div className="text-sm">Milestone {milestone.number}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Patients per Site Chart */}
        <div className="bg-white p-4 rounded-lg shadow-lg">
          <h3 className="text-lg font-medium mb-4">Patients eligible per site</h3>
          <div className="relative h-80">
            {/* Y-axis label - offset from chart */}
            <div className="absolute left-0 top-0 h-64 flex flex-col justify-center">
              <div className="transform -rotate-90 translate-y-0 text-sm text-gray-500 whitespace-nowrap ml-[-20px]">
                N° of patients
              </div>
            </div>

            {/* Main chart container */}
            <div className="ml-10 h-full flex flex-col">
              {/* Chart bars area */}
              <div className="h-64 flex items-end">
                {siteData.length > 0 ? (
                  siteData.map((site) => {
                    const barHeight = (Number(site.count) / maxSiteCount) * 200
                    console.log(`Site ${site.site_name} (count: ${site.count}) - Calculated height: ${barHeight}px`)
                    return (
                      <div key={site.number} className="flex flex-col items-center flex-1 justify-end">
                        <div
                          className="w-4/5 bg-blue-200 rounded-t-3xl flex items-center justify-center"
                          style={{ height: `${barHeight}px` }}
                        >
                          <span className="font-medium py-2">{site.count}</span>
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <div className="flex items-center justify-center w-full h-full text-gray-500">
                    No site data available.
                  </div>
                )}
              </div>

              {/* Baseline (border-b) */}
              <div className="w-full border-b border-gray-300"></div>

              {/* Site labels below baseline */}
              <div className="w-full flex mt-2">
                {siteData.map((site, index) => (
                  <div key={site.number} className="flex-1 text-center">
                    <div className="text-sm">Site {index + 1}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Latest Enrollments Table */}
      <div className="mt-12">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-medium">Latest enrolments</h3>
          <button className="text-linkColor text-sm">See all</button>
        </div>
        <div className="overflow-x-auto bg-tableau-bg rounded-2xl shadow-sm">
          <table className="min-w-full">
            <thead className="bg-tableau-bg1 border-b border-[#0302291A]">
              <tr>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-700">
                  <div className="flex items-center">
                    Patient ID
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                      ></path>
                    </svg>
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-700">
                  <div className="flex items-center">
                    Status
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                      ></path>
                    </svg>
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-700">
                  <div className="flex items-center">
                    Master ICF Version
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                      ></path>
                    </svg>
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-700">
                  <div className="flex items-center">
                    Milestone
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                      ></path>
                    </svg>
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-700">
                  <div className="flex items-center">
                    Investigator
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                      ></path>
                    </svg>
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-700">
                  <div className="flex items-center">
                    Site
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                      ></path>
                    </svg>
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-700">
                  <div className="flex items-center">
                    Latest action
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                      ></path>
                    </svg>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {latestEnrolments.length > 0 ? (
                latestEnrolments.map((patient) => (
                  <tr key={patient.patient_id} className="bg-tableau-bg1 border-b border-[#0302291A]">
                    <td className="py-3 px-6 text-sm">{formatPatientId(patient.patient_id)}</td>
                    <td className="py-3 px-6 text-sm">{patient.patient_status}</td>
                    <td className="py-3 px-6 text-sm">{patient.master_icf_title}</td>
                    <td className="py-3 px-6 text-sm">{patient.milestone_title}</td>
                    <td className="py-3 px-6 text-sm">
                      {patient.investigator_first_name} {patient.investigator_last_name}
                    </td>
                    <td className="py-3 px-6 text-sm">{patient.site_name}</td>
                    <td className="py-3 px-6 text-sm">{formatDateTime(patient.last_action_timestamp)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
